<template>
  <div>
    <HeaderLogin />
    <div class="container">
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(onSubmit)" novalidate>
          <b-row class="mt-5 justify-content-center" align-v="center">
            <b-col md="4">
              <b-card title="Recuperação de palavra-passe">
                <div v-if="!sent">
                  <p class="text-sm">Introduz o teu endereço de email e envia o pedido (clica em enviar), 
                    e segue os indicações pois irás receber no teu email um link para repores a palavra-passe.</p>
                  <validation-provider
                    name="Endereço de email"
                    :rules="{ required: true }"
                    v-slot="validationContext"
                  >
                    <b-form-group label="Endereço de email" label-for="email">
                      <b-form-input
                        id="email"
                        name="email"
                        v-model="login.email"
                        :state="validateState(validationContext)"
                      ></b-form-input>
                    </b-form-group>
                  </validation-provider>
                  <div class="text-right">
                    <b-btn variant="success" :disabled="working" type="submit">Recuperar palavra-passe</b-btn>
                  </div>
                </div>

                <div v-if="sent">
                  <p>Foi enviado um email para recuperar a palavra-passe.<br>
                  <router-link to="/login">Clique aqui para iniciar sessão</router-link>
                  </p>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <FooterFront />
  </div>
</template>


<script>
import HeaderLogin from "../../containers/Header_front.vue";
import FooterFront from "../../containers/Footer_front.vue";

export default {
  name: "ForgotForm",
  data() {
    return {
      sent: false,
      login: {
        email: "",
      },
      working: false,
    };
  },
  components: {
    HeaderLogin,
    FooterFront,
    // Header
  },
  methods: {
    onSubmit() {
      this.working = true;
      // e.preventDefault();      
      // var redirectTo = { name: "login" };
      const data = {
        email: this.login.email,
      };
      console.log("data",data)
     
      this.axios.post("auth/sendreset", data).then(() => {
        this.$bvToast.toast("Foi enviado um email para recuperar a palavra-passe", {
            autoHideDelay: 5000,
            variant: "success",
            solid: true,
          });
          this.sent = true
      }).catch(() => {
        this.working = false;
          this.$bvToast.toast(
            "Endereço de email ou palavra-passe incorrectos",
            { autoHideDelay: 5000, variant: "danger", solid: true }
          );
      })      
    },
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>

<style>
body {
  background-color: #e4e5e6 !important;
}

.text-sm {
  font-size: 0.8rem;
}
</style>